export const HOME_ROUTE = '/'
export const LOGIN_ROUTE = '/login'
export const REGISTRATION_ROUTE = '/registration'
export const OFFICE_ROUTE = '/office'
export const FOOD_ROUTE = '/food'
export const PROGRESS_ROUTE = '/progress'
export const DETAILS_ROUTE = '/details/:id'